export const initBlog = () => {
  document.querySelectorAll(".blog-feed").forEach((blog) => {
    const categories = blog.querySelectorAll(".categories li");
    const teasers = blog.querySelectorAll(".blog-teaser");

    if (!categories || !teasers) return;

    // Update category selected state.
    const updateCategoryState = (selected) => {
      categories.forEach((category) => {
        category.dataset.selected = (category.dataset.category === selected).toString();
      });
    };

    categories.forEach((category) => {
      // Add click event listener to category button.
      category.addEventListener(
        "click",
        () => {
          const target = category.dataset.category || "";

          updateCategoryState(target);

          // Update teaser visibility based on selected category.
          teasers.forEach((teaser) => {
            const teaserCategories = (teaser.dataset.categories || "").split(", ");
            teaser.classList.toggle("hidden", !teaserCategories.includes(target) && target !== "");
          });
        },
        { passive: true }
      );
    });
  });
};
